// extracted by mini-css-extract-plugin
export default {"image":"TrademarkImageModal_image__mkfHO","classInfos":"TrademarkImageModal_classInfos__HxXAa"};